import { Field } from '../../util/components/resource/resource-fields';
import { ApiResource } from '../api-resource';
import { Endpoint } from '../api.decorators';
import { Customer } from '../customer/customer.model';
import { Staff } from '../staff/staff.model';
import { DocumentType } from './lib/document.interfaces';
import { documentTypeLabels } from './lib/document.i18n';

@Endpoint('documents', 'Document')
export class Document extends ApiResource<Document> {
  @Field({ includeFilter: false })
  blob!: string;

  @Field({ type: () => DocumentType, label: $localize`Type` })
  type!: DocumentType;

  @Field({ includeFilter: false })
  metadata?: Record<string, any>;

  @Field({ label: $localize`Customer` })
  customer?: Customer;

  @Field({ label: $localize`Staff` })
  staff?: Staff;

  get owner(): Customer | Staff {
    const owner = this.staff ?? this.customer;
    if (!owner) throw new Error(`Missing required document owner (${this.id})`);
    return owner;
  }

  override toLabel(): string {
    return documentTypeLabels[this.type] + ' ' + this.owner.fullName;
  }
}
